import React from 'react'
import { NextPage } from 'next'
import { PagePropsWrapper, SEOFriendlyInitialProps } from 'lib/routing/nextPageUtils'
import { fetchArticles, UseArticlesInterface } from 'services/ContentfulService/hooks/articles'
import { FeaturedConstraint, OrderByNewestConstraint } from 'services/ContentfulService/constraints'
import { ArticleSummary, summarizeArticles } from 'services/ContentfulService/models/articles'
import { NamedPromises } from 'lib'
import { getTopics } from 'services/ContentfulService/hooks/topics'
import { Topic } from 'services/ContentfulService/models/topics'
import { ContentfulHookProps } from 'services/ContentfulService/hooks/template'
import { Product } from 'services/ContentfulService/models/product'
import { getRootProducts } from 'services/ContentfulService/hooks/products'
import { getPartners } from 'services/ContentfulService/models/partner/hooks'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import { FAQ } from 'services/ContentfulService/models/fact'
import { getFaqsByFionaTopic } from 'services/ContentfulService/hooks/faqs'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { LearnHomePage } from 'experiences/learn/overview'

interface LearnRootProps {
	products: Product[]
	featuredArticles: ArticleSummary[]
	latestArticles: ArticleSummary[]
	featuredTopics: Topic[]
	partners: Partner[]
	faqs: FAQ[]
}

const featuredTopicsInput: ContentfulHookProps = { constraints: [FeaturedConstraint()], count: 4 }
const featuredArticlesInput: UseArticlesInterface = { constraints: [FeaturedConstraint()], count: 3 }
const latestArticlesInput: UseArticlesInterface = { constraints: [OrderByNewestConstraint()], count: 8 }
const LearnPage: NextPage<PagePropsWrapper<LearnRootProps>> = ({ metaTags, pageProps }) => {
	return (
		<StandardLayout metaTags={metaTags} schemas={[{ '@type': 'FAQ', faqs: pageProps.faqs, title: 'Fiona FAQs' }]}>
			<LearnHomePage
				featuredTopics={pageProps.featuredTopics}
				featuredArticles={pageProps.featuredArticles}
				latestArticles={pageProps.latestArticles}
				partners={pageProps.partners}
				products={pageProps.products}
				faqs={pageProps.faqs}
			/>
		</StandardLayout>
	)
}

LearnPage.getInitialProps = SEOFriendlyInitialProps<LearnRootProps>(async () => {
	return await NamedPromises({
		featuredArticles: fetchArticles(featuredArticlesInput).then(summarizeArticles),
		latestArticles: fetchArticles(latestArticlesInput).then(summarizeArticles),
		featuredTopics: getTopics(featuredTopicsInput),
		partners: getPartners({ constraints: [], count: 4 }),
		products: getRootProducts(),
		faqs: getFaqsByFionaTopic()
	})
})

export default LearnPage
